import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarConfiguracoesPorId(api, parametros) {        
    parametros.operacao = 'buscarConfiguracoesPorId';

    let retorno = {};

    await api.santriGET('/rest/configuracaoUsuarioADMWeb', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarConfiguracoesPorChave(api, parametros) {        
    parametros.operacao = 'buscarConfiguracoesPorChave';

    let retorno = {};

    await api.santriGET('/rest/configuracaoUsuarioADMWeb', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async gravarConfiguracao(api, parametros) {        
    parametros.operacao = 'gravarConfiguracao';

    let retorno = {};

    await api.santriPOST('/rest/configuracaoUsuarioADMWeb', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async excluirConfiguracao(api, parametros) {        
    parametros.operacao = 'excluirConfiguracao';

    let retorno = {};

    await api.santriPOST('/rest/configuracaoUsuarioADMWeb', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RConfiguracaoUsuarioADMWeb.js